export default __webpack_public_path__ + "static/media/logo-std.65c162bb.png";